import { create } from 'zustand';

import { DateFilterVariant } from './variants';

interface DateRange {
  from: Date;
  to: Date;
}

interface State {
  selectedDateRange: Partial<{
    [id: string]: DateRange | null;
  }>;
}

interface Actions {
  setSelectedDateRange: (id: string, range: DateRange | null) => void;
}

interface Store extends State, Actions {}

const getCurrentWeekRange = (): DateRange => {
  const today = new Date();

  const from = new Date(today);

  from.setDate(today.getDate() - today.getDay());

  const to = today;

  return { from, to };
};

const initState: State = {
  selectedDateRange: Object.values(DateFilterVariant).reduce((acc, variant) => {
    acc[variant] = getCurrentWeekRange();

    return acc;
  }, {} as Record<DateFilterVariant, DateRange | null>),
};

export const useDateRangeStore = create<Store>(set => ({
  ...initState,

  setSelectedDateRange: (id, range) => {
    set(state => {
      const updatedRange = { ...state.selectedDateRange, [id]: range };

      return { selectedDateRange: updatedRange };
    });
  },
}));
